module.exports = __webpack_public_path__ + "img/Axel_halo.3dc27b00.png";